import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteStepImageUploadMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteStepImageUploadMutation = { __typename?: 'RootMutationType', deleteStepImageUpload?: { __typename?: 'ActionResult', userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const DeleteStepImageUploadDocument = gql`
    mutation deleteStepImageUpload($id: ID!) {
  deleteStepImageUpload(id: $id) {
    userErrors {
      field
      message
    }
  }
}
    `;
export type DeleteStepImageUploadMutationFn = Apollo.MutationFunction<DeleteStepImageUploadMutation, DeleteStepImageUploadMutationVariables>;

/**
 * __useDeleteStepImageUploadMutation__
 *
 * To run a mutation, you first call `useDeleteStepImageUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStepImageUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStepImageUploadMutation, { data, loading, error }] = useDeleteStepImageUploadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStepImageUploadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStepImageUploadMutation, DeleteStepImageUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStepImageUploadMutation, DeleteStepImageUploadMutationVariables>(DeleteStepImageUploadDocument, options);
      }
export type DeleteStepImageUploadMutationHookResult = ReturnType<typeof useDeleteStepImageUploadMutation>;
export type DeleteStepImageUploadMutationResult = Apollo.MutationResult<DeleteStepImageUploadMutation>;
export type DeleteStepImageUploadMutationOptions = Apollo.BaseMutationOptions<DeleteStepImageUploadMutation, DeleteStepImageUploadMutationVariables>;